// Dataset del filtro:
const id_filter_style    = '85980',
      id_filter_color    = '85981',
      id_filter_gender   = '85982',
      id_filter_size     = '85983',
      id_filter_price    = '85984',
      id_filter_jb_style = '85985';

// Configuración del Observador:
const filter_observer_config = { 
    childList: true, 
    subtree: true 
};

// Configuración de Regex: 
const regex_woman = /mujer/i,
      regex_man   = /hombre/i,
      regex_kids  = /ninos/i,
      regex_jb    = /jibbitz/i;


// Configuración de arreglo de tallas: 
const woman_sizes = ['M33','M34','M35','M36','M37','M38','M39','M40','M41','M42'];
const man_sizes =   ['H34','H35','H36','H37','H38','H39','H40','H41','H42','H43','H44','H45','H46'];
const kids_sizes =  ['K21','K22','K23','K24','K25','K26','K27','K28','J29','J30','J31','J32','J33','J34','J35','J36','J37'];

const woman_sizes_us = ['M3','M4','M5','M6','M7','M8','M9','M10','M11','M12'];
const man_sizes_us =   ['H3','H4','H5','H6','H7','H8','H9','H10','H11','H12','H13','H14','H15'];
const kids_sizes_us =  ['K3','K4','K5','K6','K7','K8','K9','K10','J11','J12','J13','J1','J2','J3','J4','J5','J6'];


// Configuración de Regex por letra: 
const regex_woman_letter = /M/g;
const regex_man_letter = /H/g;
const regex_kids_letter = /K/g;
const regex_junior_letter = /J/g;

// Mensajes: 
const select_gender_message_html = `<span id="alertSize" style=" font-size: 13px; padding-top: 6px; padding-left: 16px;">Por favor selecciona tu género.</span>`;  

// Selector de labels de los tags: 
const tag_sizes_selector = "#gf-tree .globo-selected-items-wrapper .gf-block-content .selected-item a .selected-item strong .gf-label"; 

function clearSizeTags(gender, url, selector, letter, array) {

    selector = document.querySelectorAll(selector); 

    if (gender.test(url)) {          
        selector.forEach(element => {

            let size = element.textContent;              
            let clean_size = array.find(e => size.includes(e));

            if(clean_size) {
                clean_size = clean_size.replace(letter, '');
                element.textContent = clean_size;
            }

        });
    }
}


function renderJibbitzCollectionImg(e, img_url, data){   

    let jbtz_category = document.querySelector(`.jibbitz-filter-container[data-jibbitz-category='${data}']`);

   if(!jbtz_category){
    e.insertAdjacentHTML('beforebegin', 
    `<span class="jibbitz-filter-container" data-jibbitz-category="${data}"> 
        <div class="jibbitz-filter" style="display: flex; justify-content: center; align-items: center;">
            <img class="jibbitz-filter__img" src="${img_url}" alt="${e.getAttribute('title')}">
        </div> 
    </span>
    `);  
   }
  
};



function createChangeSizeButton(){


    // let alert_size = document.getElementById('alertSize');
    // let size_container = document.querySelector('#gf-tree .gf-filter-contents div[data-filter-id="85983"]');
    let size_content = document.querySelector('#gf-tree .gf-filter-contents div[data-filter-id="85983"] .gf-block-content .gf-scroll');
    let change_size_btn = document.getElementById('gf-change-size');


    if(size_content && change_size_btn === null){
        if(localStorage.getItem('size_type') === 'eu'){
            size_content.insertAdjacentHTML('beforeEnd', '<span id="gf-change-size">Talla Americana</span>');
            size_content.display = 'block';
        } else {
            size_content.insertAdjacentHTML('beforeEnd', '<span id="gf-change-size">Talla Europea</span>');
            size_content.display = 'block';
        }
       
    }
}





var control_assign_event = false;
var url_control = window.location.href;




function assignChangeSizeButtonEvent(){

    let url = location.href;
    let change_size_btn = document.getElementById('gf-change-size');
    let size_content = document.querySelector('#gf-tree .gf-filter-contents div[data-filter-id="85983"] .gf-block-content .gf-scroll'); 

   


    if(url !== url_control){
        url_control = url; 
        control_assign_event = false;
    }

    if(change_size_btn && size_content){
        
        let size_active = false;

        let size_type = localStorage.getItem('size_type');
        
        
        // Asigna los valores de acuerdo a la talla que almacenó el usuario: 
        if(size_type){
            let sizes_values = document.querySelectorAll('#gf-tree .gf-filter-contents div[data-filter-id="85983"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label');
            if(size_type === 'eu'){
                assignSizeValues(sizes_values, url, false); 
                size_active = false; 
            } else if (size_type === 'us') {
                assignSizeValues(sizes_values, url, true);  
                size_active = true; 
            }
        }


       

        if(control_assign_event === false){

            control_assign_event = true;

            change_size_btn.addEventListener('click', (event) => { 
                
                size_active = !size_active;

                if (size_active) { 
                    document.getElementById('gf-change-size').innerText = 'Talla Europea'; 
                    localStorage.setItem('size_type', 'us');
                 } else { 
                    document.getElementById('gf-change-size').innerText = 'Talla Americana'; 
                    localStorage.setItem('size_type', 'eu'); 
                }
                        
        
                let sizes_values = document.querySelectorAll('#gf-tree .gf-filter-contents div[data-filter-id="85983"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label');

                if(sizes_values){                    
                  assignSizeValues(sizes_values, url, size_active);                    
                }
            

                event.preventDefault();
                event.stopPropagation();
            });   
        } 
    }
}


function assignSizeValues(sizes_values, url, size_active){

    if(regex_woman.test(url)){


        sizes_values.forEach(e => {
            
            if(size_active){
                switch (e.innerText){
                    case '33':  e.innerText = '3';  break;
                    case '34':  e.innerText = '4';  break;
                    case '35':  e.innerText = '5';  break;
                    case '36':  e.innerText = '6';  break;
                    case '37':  e.innerText = '7';  break;
                    case '38':  e.innerText = '8';  break;
                    case '39':  e.innerText = '9';  break;
                    case '40':  e.innerText = '10'; break;
                    case '41':  e.innerText = '11'; break;
                    case '42':  e.innerText = '12'; break;
                }           
            } else {
                switch (e.innerText){
                    case '3':   e.innerText = '33'; break;
                    case '4':   e.innerText = '34'; break;
                    case '5':   e.innerText = '35'; break;
                    case '6':   e.innerText = '36'; break;
                    case '7':   e.innerText = '37'; break;
                    case '8':   e.innerText = '38'; break;
                    case '9':   e.innerText = '39'; break;
                    case '10':  e.innerText = '40'; break;
                    case '11':  e.innerText = '41'; break;
                    case '12':  e.innerText = '42'; break;
                }   
            }

        });
    } else if(regex_man.test(url)){
        sizes_values.forEach(e => {
            if(size_active){
                switch (e.innerText){
                    case '34':  e.innerText = '3';  break;
                    case '35':  e.innerText = '4';  break;
                    case '36':  e.innerText = '5';  break;
                    case '37':  e.innerText = '6';  break;
                    case '38':  e.innerText = '7';  break;
                    case '39':  e.innerText = '8';  break;
                    case '40':  e.innerText = '9';  break;
                    case '41':  e.innerText = '10'; break;
                    case '42':  e.innerText = '11'; break;
                    case '43':  e.innerText = '12'; break;
                    case '44':  e.innerText = '13'; break;
                    case '45':  e.innerText = '14'; break;
                    case '46':  e.innerText = '15'; break;
                }           
            } else {
                switch (e.innerText){
                    case '3':   e.innerText = '34'; break;
                    case '4':   e.innerText = '35'; break;
                    case '5':   e.innerText = '36'; break;
                    case '6':   e.innerText = '37'; break;
                    case '7':   e.innerText = '38'; break;
                    case '8':   e.innerText = '39'; break;
                    case '9':   e.innerText = '40'; break;
                    case '10':  e.innerText = '41'; break;
                    case '11':  e.innerText = '42'; break;
                    case '12':  e.innerText = '43'; break;
                    case '13':  e.innerText = '44'; break;
                    case '14':  e.innerText = '45'; break;
                    case '15':  e.innerText = '46'; break;
                }   
            }
        });
    } else if(regex_kids.test(url)){
        sizes_values.forEach(e => {
            if(size_active){
                switch (e.innerText){
                    case '21':  e.innerText = '3';  break;
                    case '22':  e.innerText = '4';  break;
                    case '23':  e.innerText = '5';  break;
                    case '24':  e.innerText = '6';  break;
                    case '25':  e.innerText = '7';  break;
                    case '26':  e.innerText = '8';  break;
                    case '27':  e.innerText = '9';  break;
                    case '28':  e.innerText = '10'; break;
                    case '29':  e.innerText = '11'; break;
                    case '30':  e.innerText = '12'; break;
                    case '31':  e.innerText = '13'; break;
                    case '32':  e.innerText = '1';  break;
                    case '33':  e.innerText = '2';  break;
                    case '34':  e.innerText = '3';  break;
                    case '35':  e.innerText = '4';  break;
                    case '36':  e.innerText = '5';  break;
                    case '37':  e.innerText = '6';  break;
                }           
            } else {
                switch (e.innerText){
                    case '3':  e.innerText = '21'; break;
                    case '4':  e.innerText = '22'; break;
                    case '5':  e.innerText = '23'; break;
                    case '6':  e.innerText = '24'; break;
                    case '7':  e.innerText = '25'; break;
                    case '8':  e.innerText = '26'; break;
                    case '9':  e.innerText = '27'; break;
                    case '10': e.innerText = '28'; break;
                    case '11': e.innerText = '29'; break;
                    case '12': e.innerText = '30'; break;
                    case '13': e.innerText = '31'; break;
                    case '1':  e.innerText = '32'; break;
                    case '2':  e.innerText = '33'; break;
                    case '3':  e.innerText = '34'; break;
                    case '4':  e.innerText = '35'; break;
                    case '5':  e.innerText = '36'; break;
                    case '6':  e.innerText = '37'; break;
                }   
            }
        });
    }  
}

// window.addEventListener('load', function() {

   
//     if(!localStorage.getItem('size_type')){
//         localStorage.setItem('size_type', 'eu');
//     }

//     var url = window.location.pathname;   
//     const globo_filter_tree = document.getElementById('gf-tree');   
    
//     if(globo_filter_tree){

//         const jibbitz_label = document.querySelectorAll("#gf-tree .globo-selected-items-wrapper .gf-block-content .selected-item a[onclick*='85985'] .selected-item strong .gf-label");

//         jibbitz_label.forEach(e => {
//             switch (e.textContent.trim()) {
//                 case 'JIBBITZ DE ANIMALES':                   
//                     e.textContent = 'Jibbitz de Animales';
//                 break;
                
//                 case 'JIBBITZ DE COMIDA':                   
//                     e.textContent  = 'Jibbitz de Comida';
//                 break;
                
//                 case 'JIBBITZ DE DEPORTES':
//                     e.textContent  = 'Jibbitz de Deportes';
//                 break;
                
//                 case 'JIBBITZ DE INTERESES Y HOBBIES':
//                     e.textContent  = 'Jibbitz de Intereses y Hobbies';
//                 break;
                
//                 case 'JIBBITZ DE JOYERÍA':
//                     e.textContent  = 'Jibbitz de Joyería';
//                 break;
                
//                 case 'JIBBITZ DE LETRAS Y NÚMEROS':
//                     e.textContent  = 'Jibbitz de Números';
//                 break;
                
//                 case 'JIBBITZ DE NATURALEZA':
//                     e.textContent  = 'Jibbitz de Naturaleza';
//                 break;

//                 case 'JIBBITZ DE PERSONAJES':
//                     e.textContent  = 'Jibbitz de Personajes';
//                 break;
                
//                 case 'JIBBITZ DE SÍMBOLOS':
//                     e.textContent  = 'Jibbitz de Símbolos';
//                 break;        
//             }
        
//         });

//         let kids_tag = document.querySelector("#gf-tree .globo-selected-items-wrapper .gf-block-content .selected-item a[onclick*='NINOS'] .selected-item strong .gf-label"); 

//         // let kids_tag = document.querySelector("#gf-tree .globo-selected-items-wrapper .gf-block-content .selected-item a[data-fvalue='NINOS'] .selected-item strong .gf-label"); 

//         if(kids_tag){
//             kids_tag.textContent = 'Niños';
//         }     

//         let kids_size_label = document.querySelector(`#gf-tree .gf-filter-contents .gf-option-block[data-filter-id='${85982}'] .gf-block-content .gf-scroll .gf-option-box li a[title='NINOS'] .gf-label`);
//         // let kids_size_label = document.querySelector(`#gf-tree .gf-filter-contents .gf-option-block[data-filter-id='${85982}'] .gf-block-content .gf-scroll .gf-option-box li button[title='NINOS'] .gf-label`);
//         if(kids_size_label){
//             kids_size_label.textContent = 'Niños';
//         }

//         if (regex_woman.test(url)) {

//             clearSizeTags(regex_woman, url, tag_sizes_selector, regex_woman_letter, woman_sizes);

//             let filter_element = document.querySelector(`[data-filter-id="${85982}"]`);
//             if(filter_element){
//                 filter_element.style.display = 'none';
//             }
            
//             filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label`);
//             // filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li button .gf-label`);

//             filter_element.forEach(element => {

//                 let size = element.textContent;

//                 let clear_size = woman_sizes.find(e => size.includes(e)); 
//                 if(clear_size) {
//                     clear_size = clear_size.replace(/M/g, '');
//                     element.textContent = clear_size;
//                 } else {
//                     if(size.includes('H')){
//                         let li_element  = element.closest('li');
//                         li_element.style.display = 'none';
//                     }                   
//                 }   
//             });

//         } else if (regex_man.test(url)) {

//             clearSizeTags(regex_man, url, tag_sizes_selector, regex_man_letter, man_sizes);

//             let filter_element = document.querySelector(`[data-filter-id="${85982}"]`);
//             if(filter_element){
//                 filter_element.style.display = 'none';
//             }

//             filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label`);

//             filter_element.forEach(element => {

//                 let size = element.textContent;        

//                 let clear_size = man_sizes.find(e => size.includes(e));
   
//                 if(clear_size) {
//                     clear_size = clear_size.replace(/H/g, '');
//                     element.textContent = clear_size;
//                 } else {
//                     if(size.includes('M')){
//                         let li_element  = element.closest('li');
//                         li_element.style.display = 'none';
//                     }                   
//                 }                
//             });

//         } else if (regex_kids.test(url)){

//             clearSizeTags(regex_kids, url, tag_sizes_selector, regex_kids_letter, kids_sizes);
//             clearSizeTags(regex_kids, url, tag_sizes_selector, regex_junior_letter, kids_sizes);

//             let filter_element = document.querySelector(`[data-filter-id="${85982}"]`);
//             if(filter_element){
//                 filter_element.style.display = 'none';
//             }

//             filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label`);

//             filter_element.forEach(element => {

//                 let size = element.textContent;

//                 let clear_size = kids_sizes.find(e => size.includes(e));
//                 if(clear_size) {
//                     clear_size = clear_size.replace(/K/g, '');
//                     clear_size = clear_size.replace(/J/g, '');
//                     element.textContent = clear_size;
//                 }                 
//             });

//             var box = document.querySelector(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box`);

//             if(box) {

//                 box.style.gridTemplateColumns = '1fr';

//                 var list_elements = box.querySelectorAll('li');
//                 var list_elements_array = Array.from(list_elements);

//                 list_elements_array.sort(function(a, b) {
//                     var a_element = a.textContent.toLowerCase();
//                     var b_element = b.textContent.toLowerCase();
//                     return a_element.localeCompare(b_element);
//                 });
                
//                 list_elements_array.forEach(function(e) {
//                     box.appendChild(e);
//                 });                

//                 var ul_kids = document.createElement('ul');
//                 ul_kids.id = 'kids';
//                 ul_kids.classList.add('gf-option-box');

//                 var ul_juniors = document.createElement('ul');
//                 ul_juniors.id = 'juniors';
//                 ul_juniors.classList.add('gf-option-box');   

//                 list_elements.forEach(function(elemento) {
//                     var a = elemento.querySelector('a');
//                     var title = a.getAttribute('title');
//                     if (title.includes('K')) {
//                         ul_kids.appendChild(elemento);
//                     } else if (title.includes('J')) {
//                         ul_juniors.appendChild(elemento);
//                     }
//                 });

//                 box.innerHTML = '';
//                 box.appendChild(ul_kids);
//                 box.appendChild(ul_juniors);

//                 ul_kids = document.querySelector('#kids');
//                 ul_juniors = document.querySelector('#juniors');

//                 ul_kids.insertAdjacentHTML('beforebegin', `<span class="kids-size__title">Niños Pequeños (Edades 1-5)</span>`);
//                 ul_juniors.insertAdjacentHTML('beforebegin', `<span class="kids-size__title">Niños Grandes (Edades 6+)</span>`);
//             }

//         } else if (regex_jb.test(url)) {
//             const jibbitz_gf_img = document.querySelectorAll(`#gf-tree .gf-filter-contents .gf-option-block[data-filter-id='${85985}'] .gf-block-content .gf-scroll .gf-option-box li`);
//             const jibbitz_gf_tree = document.querySelectorAll(`#gf-tree .gf-filter-contents .gf-option-block[data-filter-id='${85985}'] .gf-block-content .gf-scroll .gf-option-box li a`);     
//             let jibbitz_category_name = '';


//             if(jibbitz_gf_img.length <= jibbitz_gf_tree.length){
//                 jibbitz_gf_tree.forEach(e => {      
//                     switch(e.getAttribute('title')){
//                         case 'JIBBITZ DE ANIMALES':
//                             renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/animals.png?v=1676913090', 'animales');
//                             jibbitz_category_name = 'Jibbitz de Animales';
//                         break;
                        
//                         case 'JIBBITZ DE COMIDA':
//                             renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/food-drink.png?v=1676913090', 'comida');
//                             jibbitz_category_name = 'Jibbitz de Comida';
//                         break;
                        
//                         case 'JIBBITZ DE DEPORTES':
//                             renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/sports.png?v=1676913090', 'deportes');
//                             jibbitz_category_name = 'Jibbitz de Deportes';
//                         break;
                        
//                         case 'JIBBITZ DE INTERESES Y HOBBIES':
//                             renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/hobbies-interests.png?v=1676913090', 'intereses-y-hobbies');
//                             jibbitz_category_name = 'Jibbitz de Intereses y Hobbies';
//                         break;
                        
//                         case 'JIBBITZ DE JOYERÍA':
//                             renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/jewels-metals.png?v=1676913090', 'joyeria');
//                             jibbitz_category_name = 'Jibbitz de Joyería';
//                         break;
                        
//                         case 'JIBBITZ DE LETRAS Y NÚMEROS':
//                             renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/letters_-_numbers.png?v=1677535740', 'numeros');
//                             jibbitz_category_name = 'Jibbitz de Números';
//                         break;
                        
//                         case 'JIBBITZ DE NATURALEZA':
//                             renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/flower-nature.png?v=1676913090', 'naturaleza');
//                             jibbitz_category_name = 'Jibbitz de Naturaleza';
//                         break;
    
//                         case 'JIBBITZ DE PERSONAJES':
//                             renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/character.png?v=1676913090', 'personajes');
//                             jibbitz_category_name = 'Jibbitz de Personajes';
//                         break;
                        
//                         case 'JIBBITZ DE SÍMBOLOS':
//                             renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/jibbitz-symbols-sayings.png?v=1676907433', 'simbolos');
//                             jibbitz_category_name = 'Jibbitz de Símbolos';
//                         break;                    
//                     }
//                     e.querySelector('.gf-label').textContent = jibbitz_category_name;             
//                 }); 
//             }  

//         } else {
//             // Revisar por si las moscas. → 
//             let url_href = window.location.href;
//             var control = false;
//             let filter_element = document.querySelectorAll(`[data-filter-id="${85982}"] .gf-block-content .gf-scroll .gf-option-box li a`);

//             filter_element.forEach(e => {

//                 if(e.classList.contains('checked')) {                       
//                     control = true;  
//                     let title = e.getAttribute('title');  

//                     if(regex_woman.test(title)) {

//                         clearSizeTags(regex_woman, url_href, tag_sizes_selector, regex_woman_letter, woman_sizes);

//                         filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label`);

//                         filter_element.forEach(element => {

//                             let size = element.textContent;

//                             let clear_size = woman_sizes.find(e => size.includes(e));
//                             if(clear_size) {
//                                 clear_size = clear_size.replace(/M/g, '');
//                                 element.textContent = clear_size;
//                             } else {
//                                 if(size.includes('H')){
//                                     let li_element  = element.closest('li');
//                                     li_element.style.display = 'none';
//                                 }                               
//                             }                            
//                         });

//                     }else if (regex_man.test(title)) {

//                         clearSizeTags(regex_man, url_href, tag_sizes_selector, regex_man_letter, man_sizes);

//                         filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label`);

//                         filter_element.forEach(element => {

//                             let size = element.textContent;             

//                             let clear_size = man_sizes.find(e => size.includes(e));
//                             if(clear_size) {
//                                 clear_size = clear_size.replace(/H/g, '');
//                                 element.textContent = clear_size;
//                             } else {
//                                 if(size.includes('M')){
//                                     let li_element  = element.closest('li');
//                                     li_element.style.display = 'none';
//                                 }                            
//                             }                            
//                         });

//                     }else if (regex_kids.test(title)) {

//                         clearSizeTags(regex_kids, url_href, tag_sizes_selector, regex_kids_letter, kids_sizes);
//                         clearSizeTags(regex_kids, url_href, tag_sizes_selector, regex_junior_letter, kids_sizes);

//                         filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label`);

//                         filter_element.forEach(element => {

//                             let size = element.textContent;

//                             let clear_size = kids_sizes.find(e => size.includes(e));
//                             if(clear_size) {
//                                 clear_size = clear_size.replace(/K/g, '');
//                                 clear_size = clear_size.replace(/J/g, '');
//                                 element.textContent = clear_size;
//                             }                       
//                         });

//                         var box = document.querySelector(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box`);

//                         if(box){
//                             box.style.gridTemplateColumns = '1fr';
                        
//                             var list_elements = box.querySelectorAll('li');

//                             var list_elements_array = Array.from(list_elements);

//                             list_elements_array.sort(function(a, b) {
//                                 var a_element = a.textContent.toLowerCase();
//                                 var b_element = b.textContent.toLowerCase();
//                                 return a_element.localeCompare(b_element);
//                             });
                            
//                             list_elements_array.forEach(function(e) {
//                                 box.appendChild(e);
//                             });
                            
//                             var ul_kids = document.createElement('ul');
//                             ul_kids.id = 'kids';
//                             ul_kids.classList.add('gf-option-box');

//                             var ul_juniors = document.createElement('ul');
//                             ul_juniors.id = 'juniors';
//                             ul_juniors.classList.add('gf-option-box');

//                             list_elements.forEach(function(e) {
//                                 var a = e.querySelector('a');
//                                 var title = a.getAttribute('title');
//                                 if (title.includes('K')) {
//                                     ul_kids.appendChild(e);
//                                 } else if (title.includes('J')) {
//                                     ul_juniors.appendChild(e);
//                                 }
//                             });

//                             box.innerHTML = '';
//                             box.appendChild(ul_kids);
//                             box.appendChild(ul_juniors);

//                             ul_kids = document.querySelector('#kids');
//                             ul_juniors = document.querySelector('#juniors');

//                             ul_kids.insertAdjacentHTML('beforebegin', `<span class="kids-size__title">Niños Pequeños (Edades 1-5)</span>`);
//                             ul_juniors.insertAdjacentHTML('beforebegin', `<span class="kids-size__title">Niños Grandes (Edades 6+)</span>`);

//                         }
                        
//                     }
//                 }  
//             }); 

//             filter_element = document.querySelectorAll(`[data-filter-id="${85982}"] .gf-block-content .gf-scroll .gf-option-box li a`);
//             filter_element.forEach(e => {
//                 if (!e.classList.contains('checked') && control === true){
//                     e.parentNode.style.display = 'none'; 
//                 }
//             });
            
//             if(control === false){

//                 let filter_element = document.querySelector(`[data-filter-id="${85983}"] .gf-block-content`);                
//                 if(filter_element){
//                     filter_element.innerHTML =  select_gender_message_html;
//                 }

//                 let clean_size_button = document.querySelector(`[data-filter-id="${85983}"] .gf-block-title .gf-clear`);
//                 if(clean_size_button){
//                     clean_size_button.click();
//                 }
//             }               
//         }
//     }

//     createChangeSizeButton();
//     assignChangeSizeButtonEvent();
//     // changeSizeType();

//     const filter_observer = new MutationObserver((mutationsList, filter_observer) => {

//         var control_assign_event = false;
//         var url_control = window.location.href;


//         if(!localStorage.getItem('size_type')){
//             localStorage.setItem('size_type', 'eu');
//     }

//         var url_href = window.location.href;

//         const globo_filter_tree = document.getElementById('gf-tree');   

//         if (globo_filter_tree.children.length > 0) {

//             const jibbitz_label = document.querySelectorAll("#gf-tree .globo-selected-items-wrapper .gf-block-content .selected-item a[onclick*='85985'] .selected-item strong .gf-label");

//             jibbitz_label.forEach(e => {
//                 switch (e.textContent.trim()) {
//                     case 'JIBBITZ DE ANIMALES':                   
//                         e.textContent = 'Jibbitz de Animales';
//                     break;
                    
//                     case 'JIBBITZ DE COMIDA':                   
//                         e.textContent  = 'Jibbitz de Comida';
//                     break;
                    
//                     case 'JIBBITZ DE DEPORTES':
//                         e.textContent  = 'Jibbitz de Deportes';
//                     break;
                    
//                     case 'JIBBITZ DE INTERESES Y HOBBIES':
//                         e.textContent  = 'Jibbitz de Intereses y Hobbies';
//                     break;
                    
//                     case 'JIBBITZ DE JOYERÍA':
//                         e.textContent  = 'Jibbitz de Joyería';
//                     break;
                    
//                     case 'JIBBITZ DE LETRAS Y NÚMEROS':
//                         e.textContent  = 'Jibbitz de Números';
//                     break;
                    
//                     case 'JIBBITZ DE NATURALEZA':
//                         e.textContent  = 'Jibbitz de Naturaleza';
//                     break;

//                     case 'JIBBITZ DE PERSONAJES':
//                         e.textContent  = 'Jibbitz de Personajes';
//                     break;
                    
//                     case 'JIBBITZ DE SÍMBOLOS':
//                         e.textContent  = 'Jibbitz de Símbolos';
//                     break;        
//                 }
            
//             });

//             let kids_tag = document.querySelector("#gf-tree .globo-selected-items-wrapper .gf-block-content .selected-item a[onclick*='NINOS'] .selected-item strong .gf-label"); 
//             // let kids_tag = document.querySelector("#gf-tree .globo-selected-items-wrapper .gf-block-content .selected-item a[data-fvalue='NINOS'] .selected-item strong .gf-label"); 
//             if(kids_tag){
//                 kids_tag.textContent = 'Niños';
//             }

//             let kids_size_label = document.querySelector(`#gf-tree .gf-filter-contents .gf-option-block[data-filter-id='${85982}'] .gf-block-content .gf-scroll .gf-option-box li a[title='NINOS'] .gf-label`);    
//             if(kids_size_label){
//                 kids_size_label.textContent = 'Niños';
//             }       

//             if (regex_woman.test(url)) {

//                 clearSizeTags(regex_woman, url, tag_sizes_selector, regex_woman_letter, woman_sizes);

//                 let filter_element = document.querySelector(`[data-filter-id="${85982}"]`);
//                 filter_element.style.display = 'none';

//                 filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label`);

//                 filter_element.forEach(element => {

//                     let size = element.textContent;
   
//                     let clear_size = woman_sizes.find(e => size.includes(e));
  
//                     if(clear_size) {
//                         clear_size = clear_size.replace(/M/g, '');
//                         element.textContent = clear_size;
//                     } else {
//                         if(size.includes('H')){
//                             let li_element  = element.closest('li');
//                             li_element.style.display = 'none';
//                         }
                       
//                     }
//                     filter_observer.disconnect();                    
//                 });

//             } else if (regex_man.test(url)) {

//                 clearSizeTags(regex_man, url, tag_sizes_selector, regex_man_letter, man_sizes);

//                 let filter_element = document.querySelector(`[data-filter-id="${85982}"]`);
//                 filter_element.style.display = 'none';

//                 filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label`)

//                 filter_element.forEach(element => {

//                     let size = element.textContent;

//                     let clear_size = man_sizes.find(e => size.includes(e));
               
//                     if(clear_size) {
//                         clear_size = clear_size.replace(/H/g, '');
//                         element.textContent = clear_size;
//                     } else {
//                         if(size.includes('M')){
//                             let li_element  = element.closest('li');
//                             li_element.style.display = 'none';
//                         }                       
//                     }
//                     filter_observer.disconnect();
                    
//                 });

//             } else if (regex_kids.test(url)){

//                 clearSizeTags(regex_kids, url, tag_sizes_selector, regex_kids_letter, kids_sizes);
//                 clearSizeTags(regex_kids, url, tag_sizes_selector, regex_junior_letter, kids_sizes);                

//                 let filter_element = document.querySelector(`[data-filter-id="${85982}"]`);
//                 filter_element.style.display = 'none';

//                 filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label`);

//                 filter_element.forEach(element => {

//                     let size = element.textContent;

//                     let clear_size = kids_sizes.find(e => size.includes(e));

//                     if(clear_size) {
//                         clear_size = clear_size.replace(/K/g, '');
//                         clear_size = clear_size.replace(/J/g, '');
//                         element.textContent = clear_size;
//                     } 

//                     filter_observer.disconnect();                    
//                 });
             
//                 var box = document.querySelector(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box`);

//                 if(box){
//                     box.style.gridTemplateColumns = '1fr';
                
//                     var list_elements = box.querySelectorAll('li');
    
//                     var list_elements_array = Array.from(list_elements);
    
//                     list_elements_array.sort(function(a, b) {
//                         var a_element = a.textContent.toLowerCase();
//                         var b_element = b.textContent.toLowerCase();
//                         return a_element.localeCompare(b_element);
//                     });
                    
//                     list_elements_array.forEach(function(e) {
//                         box.appendChild(e);
//                     });
                    
//                     var ul_kids = document.createElement('ul');
//                     ul_kids.id = 'kids';
//                     ul_kids.classList.add('gf-option-box');
          
//                     var ul_juniors = document.createElement('ul');
//                     ul_juniors.id = 'juniors';
//                     ul_juniors.classList.add('gf-option-box');          
    
//                     list_elements.forEach(function(e) {
//                         var a = e.querySelector('a');
//                         var title = a.getAttribute('title');
//                         if (title.includes('K')) {
//                             ul_kids.appendChild(e);
//                         } else if (title.includes('J')) {
//                             ul_juniors.appendChild(e);
//                         }
//                     });
    
//                     box.innerHTML = '';
//                     box.appendChild(ul_kids);
//                     box.appendChild(ul_juniors);    
    
//                     ul_kids = document.querySelector('#kids');
//                     ul_juniors = document.querySelector('#juniors');
    
//                     ul_kids.insertAdjacentHTML('beforebegin', `<span class="kids-size__title">Niños Pequeños (Edades 1-5)</span>`);
//                     ul_juniors.insertAdjacentHTML('beforebegin', `<span class="kids-size__title">Niños Grandes (Edades 6+)</span>`);
//                 }               

//             } else if (regex_jb.test(url)) {
//                 const jibbitz_gf_img = document.querySelectorAll(`#gf-tree .gf-filter-contents .gf-option-block[data-filter-id='${85985}'] .gf-block-content .gf-scroll .gf-option-box li`);
//                 const jibbitz_gf_tree = document.querySelectorAll(`#gf-tree .gf-filter-contents .gf-option-block[data-filter-id='${85985}'] .gf-block-content .gf-scroll .gf-option-box li a`);
               

//                 let jibbitz_category_name = '';


//                 if(jibbitz_gf_img.length >= 0){
//                     jibbitz_gf_tree.forEach(e => {      
//                         switch(e.getAttribute('title')){
//                             case 'JIBBITZ DE ANIMALES':                              
//                                 renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/animals.png?v=1676913090', 'animales');
//                                 jibbitz_category_name = 'Jibbitz de Animales';
//                             break;
                            
//                             case 'JIBBITZ DE COMIDA':
//                                 renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/food-drink.png?v=1676913090', 'comida');
//                                 jibbitz_category_name = 'Jibbitz de Comida';
//                             break;
                            
//                             case 'JIBBITZ DE DEPORTES':
//                                 renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/sports.png?v=1676913090', 'deportes');
//                                 jibbitz_category_name = 'Jibbitz de Deportes';
//                             break;
                            
//                             case 'JIBBITZ DE INTERESES Y HOBBIES':
//                                 renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/hobbies-interests.png?v=1676913090', 'intereses-y-hobbies');
//                                 jibbitz_category_name = 'Jibbitz de Intereses y Hobbies';
//                             break;
                            
//                             case 'JIBBITZ DE JOYERÍA':
//                                 renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/jewels-metals.png?v=1676913090', 'joyeria');
//                                 jibbitz_category_name = 'Jibbitz de Joyería';
//                             break;
                            
//                             case 'JIBBITZ DE LETRAS Y NÚMEROS':
//                                 renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/letters_-_numbers.png?v=1677535740', 'numeros');
//                                 jibbitz_category_name = 'Jibbitz de Números';
//                             break;
                            
//                             case 'JIBBITZ DE NATURALEZA':
//                                 renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/flower-nature.png?v=1676913090', 'naturaleza');
//                                 jibbitz_category_name = 'Jibbitz de Naturaleza';
//                             break;
        
//                             case 'JIBBITZ DE PERSONAJES':
//                                 renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/character.png?v=1676913090', 'personajes');
//                                 jibbitz_category_name = 'Jibbitz de Personajes';
//                             break;
                            
//                             case 'JIBBITZ DE SÍMBOLOS':
//                                 renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/jibbitz-symbols-sayings.png?v=1676907433', 'simbolos');
//                                 jibbitz_category_name = 'Jibbitz de Símbolos';
//                             break;                    
//                         }
//                         e.querySelector('.gf-label').textContent = jibbitz_category_name;             
//                     }); 
//                 }    
    
//                 filter_observer.disconnect(); 
//             } else {

//                 var control = false;
               
//                 let filter_element = document.querySelectorAll(`[data-filter-id="${85982}"] .gf-block-content .gf-scroll .gf-option-box li a`);

//                 filter_element.forEach(e => {

//                     if(e.classList.contains('checked')){                       
//                         control = true;  
//                         let title = e.getAttribute('title');  
                       
//                         if(regex_woman.test(title)) {

//                             clearSizeTags(regex_woman, url_href, tag_sizes_selector, regex_woman_letter, woman_sizes);

//                             filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label`);

//                             filter_element.forEach(element => {
            
//                                 let size = element.textContent;
//                                 let clear_size = woman_sizes.find(e => size.includes(e));

//                                 if(clear_size) {
//                                     clear_size = clear_size.replace(/M/g, '');
//                                     element.textContent = clear_size;
//                                 } else {
//                                     if(size.includes('H')){
//                                         let li_element  = element.closest('li');
//                                         li_element.style.display = 'none';
//                                     }                                   
//                                 }

//                                 filter_observer.disconnect();     

//                             });

//                         }else if (regex_man.test(title)) {

//                             clearSizeTags(regex_man, url_href, tag_sizes_selector, regex_man_letter, man_sizes);

//                             filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label`);

//                             filter_element.forEach(element => {

//                                 let size = element.textContent;

//                                 let clear_size = man_sizes.find(e => size.includes(e));

//                                 if(clear_size) {
//                                     clear_size = clear_size.replace(/H/g, '');
//                                     element.textContent = clear_size;
//                                 } else {
//                                     if(size.includes('M')){
//                                         let li_element  = element.closest('li');
//                                         li_element.style.display = 'none';
//                                     }                                
//                                 }

//                                 filter_observer.disconnect();
                                
//                             });

//                         }else if (regex_kids.test(title)) {

//                             clearSizeTags(regex_kids, url_href, tag_sizes_selector, regex_kids_letter, kids_sizes);
//                             clearSizeTags(regex_kids, url_href, tag_sizes_selector, regex_junior_letter, kids_sizes);

//                             filter_element  = document.querySelectorAll(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box li a .gf-label`);

//                             filter_element.forEach(element => {

//                                 let size = element.textContent;

//                                 let clear_size = kids_sizes.find(e => size.includes(e));

//                                 if(clear_size) {
//                                     clear_size = clear_size.replace(/K/g, '');
//                                     clear_size = clear_size.replace(/J/g, '');
//                                     element.textContent = clear_size;
//                                 }

//                                 filter_observer.disconnect();
                                
//                             });

//                             var box = document.querySelector(`[data-filter-id="${85983}"] .gf-block-content .gf-scroll .gf-option-box`);

//                             if(box){

//                                 box.style.gridTemplateColumns = '1fr';
                                
//                                 var list_elements = box.querySelectorAll('li');
//                                 var list_elements_array = Array.from(list_elements);

//                                 list_elements_array.sort(function(a, b) {
//                                     var a_element = a.textContent.toLowerCase();
//                                     var b_element = b.textContent.toLowerCase();
//                                     return a_element.localeCompare(b_element);
//                                 });
                                    
//                                 list_elements_array.forEach(function(e) {
//                                     box.appendChild(e);
//                                 });
                                    
//                                 var ul_kids = document.createElement('ul');
//                                 ul_kids.id = 'kids';
//                                 ul_kids.classList.add('gf-option-box');

//                                 var ul_juniors = document.createElement('ul');
//                                 ul_juniors.id = 'juniors';
//                                 ul_juniors.classList.add('gf-option-box');
                                    
//                                 list_elements.forEach(function(e) {
//                                     var a = e.querySelector('a');
//                                     var title = a.getAttribute('title');
//                                     if (title.includes('K')) {
//                                         ul_kids.appendChild(e);
//                                     } else if (title.includes('J')) {
//                                         ul_juniors.appendChild(e);
//                                     }
//                                 });

//                                 box.innerHTML = '';
//                                 box.appendChild(ul_kids);
//                                 box.appendChild(ul_juniors);

//                                 ul_kids = document.querySelector('#kids');
//                                 ul_juniors = document.querySelector('#juniors');

//                                 ul_kids.insertAdjacentHTML('beforebegin', `<span class="kids-size__title">Niños Pequeños (Edades 1-5)</span>`);
//                                 ul_juniors.insertAdjacentHTML('beforebegin', `<span class="kids-size__title">Niños Grandes (Edades 6+)</span>`);
//                             }
//                         } 
//                     } 
//                 }); 

//                 filter_element = document.querySelectorAll(`[data-filter-id="${85982}"] .gf-block-content .gf-scroll .gf-option-box li a`);
//                 filter_element.forEach(e => {
//                     if (!e.classList.contains('checked') && control === true){
//                         e.parentNode.style.display = 'none'; 
//                     }  
//                 });

//                 if(control === false){

//                     let filter_element = document.querySelector(`[data-filter-id="${85983}"] .gf-block-content`);
//                     if(filter_element){
//                         filter_element.innerHTML =  select_gender_message_html;
//                     }

//                     let clean_size_button = document.querySelector(`[data-filter-id="${85983}"] .gf-block-title .gf-clear`);
//                     if(clean_size_button){
//                         clean_size_button.click();
//                     }
//                 }

//                 // changeSizeType();               
//                 filter_observer.disconnect();                
//             }            
//         }    

//         filter_observer.observe(globo_filter_tree, filter_observer_config);

//         createChangeSizeButton();
//         assignChangeSizeButtonEvent();


//     });

//     filter_observer.observe(globo_filter_tree, filter_observer_config);
// });



